export default __webpack_public_path__ + "static/media/csango10-logo-transparent-1.c2428399.svg";